import { shallowEqual } from "react-redux";
import { createSelector, lruMemoize } from "reselect";
import { DefaultRootState } from "stores";

export const getObjectsTransform = (state: DefaultRootState) => {
  return state.transforms.roomTransform.objectsTransform;
};

const getIsSelected = (_: any, props: { isSelected: boolean }): boolean =>
  props.isSelected;

export const getRoomObjectsTransform = createSelector(
  [getObjectsTransform, getIsSelected],
  (transform, isSelected) => {
    if (isSelected) return transform;
    return null;
  },
  {
    memoize: lruMemoize,
    memoizeOptions: {
      resultEqualityCheck: shallowEqual,
    },
  }
);
